import { render, staticRenderFns } from "./Resident.vue?vue&type=template&id=30d7142e&scoped=true"
import script from "./Resident.vue?vue&type=script&lang=js"
export * from "./Resident.vue?vue&type=script&lang=js"
import style0 from "./Resident.vue?vue&type=style&index=0&id=30d7142e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d7142e",
  null
  
)

export default component.exports